import { render, staticRenderFns } from "./material-report-table.vue?vue&type=template&id=04dc612f&scoped=true"
import script from "./material-report-table.vue?vue&type=script&lang=js"
export * from "./material-report-table.vue?vue&type=script&lang=js"
import style0 from "./material-report-table.vue?vue&type=style&index=0&id=04dc612f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc612f",
  null
  
)

export default component.exports